export const soundsURL = '/static/media/'
